import { Link } from "react-router-dom";
import styles from "./breadcrumb.module.css";

const linkStyle = {textDecoration:'none', color:'inherit'};

const Breadcrumb = (props) => {
    //console.log('breadcrumb render');
    const cursor = [];

    return (
        <div className="d-flex ms-2">
            <Link to="/root/" style={linkStyle} className={styles.folderName + " d-flex align-items-center"}><i className={styles.icon+" bi bi-hdd"}/>Root</Link>
            {
                props.path.map(folder => {
                    cursor.push(folder);
                    let path = Array.from(cursor);
                    return (
                        <span key={path} className="d-flex align-items-center">
                            <span className={styles.divider}>/</span>
                            <Link to={'/root/'+path.join('/')} style={linkStyle} className={styles.folderName}>{folder}</Link>
                        </span>
                    )
                })
            }
        </div>
    )
}

export default Breadcrumb